import { FilterGroup } from '@helios/common-api'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const filterGroupsFeatureKey = 'filterGroups'

export type FilterGroupPrefixId = {
  prefix: string
  id: string
}

export type FilterGroupWithGridPrefix = {
  gridPrefix: string
  filterGroup: FilterGroup
}

export type GridToFilterGroupMap = {
  [gridPrefix: string]: FilterGroup[]
}

export const filterGroupInitialState: GridToFilterGroupMap = {}

export const filterGroupSlice = createSlice({
  name: filterGroupsFeatureKey,
  initialState: filterGroupInitialState,
  reducers: {
    setFilterGroupsByPrefix: (
      oldState,
      action: PayloadAction<GridToFilterGroupMap>,
    ) => {
      return {
        ...oldState,
        ...action.payload,
      }
    },
    createFilterGroup: (
      oldState,
      action: PayloadAction<FilterGroupWithGridPrefix>,
    ) => {
      oldState[action.payload.gridPrefix].push(action.payload.filterGroup)
      return oldState
    },
    updateFilterGroup: (
      oldState,
      action: PayloadAction<FilterGroupWithGridPrefix>,
    ) => {
      oldState[action.payload.gridPrefix] = oldState[
        action.payload.gridPrefix
      ].map(fg =>
        fg.filterGroupPrefix == action.payload.filterGroup.filterGroupPrefix
          ? action.payload.filterGroup
          : fg,
      )
      return oldState
    },
    deleteFilterGroup: (
      oldState,
      action: PayloadAction<FilterGroupPrefixId>,
    ) => {
      oldState[action.payload.prefix] = oldState[action.payload.prefix].filter(
        fg =>
          fg.filterGroupPrefix !=
          action.payload.prefix + '/' + action.payload.id,
      )
      return oldState
    },
  },
})

export const {
  setFilterGroupsByPrefix,
  createFilterGroup,
  updateFilterGroup,
  deleteFilterGroup,
} = filterGroupSlice.actions

export default filterGroupSlice.reducer
